module.exports = __webpack_public_path__ + "static/media/r2d2_icon.caac885b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/r2d2_icon.png
// module id = 60
// module chunks = 0